import { useIntl } from 'react-intl'
import Pill from 'LuxKit/Pill/Pill'
import { usePercentFormatter } from 'hooks/useNumberFormatters'

interface Props {
  discount?: App.CruiseDiscountPillDetails
}

function CruiseBundleSavingsPill({ discount }: Props) {
  const intl = useIntl()
  const formatPercent = usePercentFormatter()

  if (!discount || !(discount.discountPrice > 0 && discount.discountPercentage > 0)) return null

  return <div>
    <Pill palette="success">
      {intl.formatMessage({
        id: 'ntDLKqsAXmZHHK505Qud',
        defaultMessage: 'Save up to {percentage}',
        description: 'Savings percentage tag above the standard cruise and hotel bundle prices on offer tiles and offer pages',
      }, { percentage: formatPercent(discount.discountPercentage / 100) })}
    </Pill>
  </div>
}

export default CruiseBundleSavingsPill
